import { atom } from 'recoil'

export const activeStepState = atom<number>({
  key: 'activeStepState',
  default: 1,
})
